import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';

@Injectable()
export class RemoteLoggingService {
  // private logginUrl = 'logging/url';

  // constructor(private http: Http) { }
  constructor() {}

  write(message: string) {
    // console.error(message);
  }
}
